import { lazy } from "react";
import Protected from "../pages/auth/Protected";
import EventCheckout from "../pages/Coach/Events/EventCheckout.jsx";
import ScheduleCartDetails from "../pages/reservation-payment/ScheduleCartDetails.jsx";
const CartDetails = lazy(() => import("../pages/reservation-payment/CartDetails"));
const ReservationCheckout = lazy(() => import("../pages/reservation-payment/ReservationCheckout"));
const PaymentInfo = lazy(() => import("../pages/payment-management/PaymentInfo.jsx"));
const PayoutForm = lazy(() => import("../pages/payout-management/PayoutForm.jsx"));
const Subscription = lazy(() => import("../pages/subscription/Subscription.jsx"));
const SubscriptionPlatform = lazy(() => import("../pages/subscription-platform/SubscriptionPlatform.jsx"));

export const paymentRoutes = [
    { path: "/payment-details", element: <Protected Component={PaymentInfo} /> },
    { path: "/finances", element: <Protected Component={PayoutForm} /> },
    {
        path: "/subscription-connected",
        element: <Protected Component={Subscription} />,
    },
    { path: '/subscription-platform', element: <Protected Component={SubscriptionPlatform} /> },
    {
        path: "/payment",
        element: <Protected Component={ReservationCheckout} />,
    },
    {
        path: "/event-checkout",
        element: <Protected Component={EventCheckout} />,
    },
    {
        path: "/cart",
        element: <Protected Component={CartDetails} />,
    },
    {
        path: "/schedule-cart",
        element: <Protected Component={ScheduleCartDetails} />,
    },
]